import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { CaseSettings } from '../../domain/case/CaseDomains';
import { ActionJsonModel } from '../../domain/collection/rule/action/ActionDomains';
import { TransactionJsonModel } from '../../domain/stream/transaction/TransactionDomains';

export type ConfigurationActions =
  | 'CHANGE_CONFIGURATION'
  | 'CHANGE_CONFIGURATION_SCHEMA'
  | 'CHANGE_CONFIGURATION_IS_UPDATE'
  | 'CLEAR_CONFIGURATION'
  | 'CHANGE_ACTIONS'
  | 'CHANGE_EVENT_ITEMS'
  | 'CHANGE_CONFIGURATION_DIRTY'
  | 'CHANGE_LISTS';

export const changeConfiguration = (payload: CaseSettings) =>
  ({
    type: 'CHANGE_CONFIGURATION',
    payload,
  }) as ReduxBaseAction<CaseSettings | null, ConfigurationActions>;

export const changeConfigurationIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_CONFIGURATION_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, ConfigurationActions>;

export const changeActions = (payload: ActionJsonModel[]) =>
  ({
    type: 'CHANGE_ACTIONS',
    payload,
  }) as ReduxBaseAction<ActionJsonModel | []>;

export const changeEventItems = (payload: TransactionJsonModel[]) =>
  ({
    type: 'CHANGE_EVENT_ITEMS',
    payload,
  }) as ReduxBaseAction<TransactionJsonModel | []>;

export const changeLists = (payload: string[]) =>
  ({
    type: 'CHANGE_LISTS',
    payload,
  }) as ReduxBaseAction<string[] | []>;

export const clearConfiguration = () =>
  ({
    type: 'CLEAR_CONFIGURATION',
    payload: void 0,
  }) as ReduxBaseAction<any, ConfigurationActions>;

export const changeConfigurationDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_CONFIGURATION_DIRTY',
    payload,
  }) as ReduxBaseAction<boolean, ConfigurationActions>;
